export default "__VITE_ASSET__T1o0DOru__"